import { useEffect } from "react";
import { COLLISION_MODE_LIST } from "../app/Data";

import useData from "../app/useData";

const KeyboardManager: React.FC<{}> = () => {
	const { moveElement, rotateElement, setCollisionMode } = useData();

	useEffect(() => {
		const onKeyPress = (event: KeyboardEvent) => {
			const target = event.target as Element;
			if (target.localName === "input" || target.localName === "select") {
				// focused element is input, ignore...
				return;
			}
			if (event.key === "c" || event.key === "C") {
				setCollisionMode(mode => {
					let index = COLLISION_MODE_LIST.indexOf(mode);
					if (index >= 0) {
						if (event.key === "C") {
							index--;
						} else {
							index++;
						}
					}
					if (index < 0) {
						index = COLLISION_MODE_LIST.length - 1;
					} else if (index >= COLLISION_MODE_LIST.length) {
						index = 0;
					}
					return COLLISION_MODE_LIST[index];
				});
			}
			if (event.altKey) {
				let axis: RotationEnum | undefined = undefined;
				const value =
					event.key === "ArrowDown" || event.key === "ArrowLeft" || event.key === "-"
						? -1
						: 1;
				switch (event.key) {
					case "ArrowDown":
					case "ArrowUp":
						axis = "rotY";
						break;
					case "ArrowLeft":
					case "ArrowRight":
						axis = "rotX";
						break;
					case "+":
					case "-":
						axis = "rotZ";
						break;
				}

				if (axis) {
					rotateElement(axis, value);
					event.preventDefault();
					event.stopPropagation();
				}
			} else {
				let axis: AxisEnum | undefined = undefined;
				let value = 0.01;
				if (event.shiftKey) {
					value = 0.1;
				}
				switch (event.key) {
					case "ArrowDown":
					case "ArrowUp":
						axis = "y";
						break;
					case "ArrowLeft":
					case "ArrowRight":
						axis = "x";
						break;
					case "+":
					case "-":
						axis = "z";
						break;
				}

				if (event.key === "ArrowDown" || event.key === "ArrowLeft" || event.key === "-") {
					value = -value;
				}

				if (axis) {
					moveElement(axis, value);
					event.preventDefault();
					event.stopPropagation();
				}
			}
		};
		document.addEventListener("keydown", onKeyPress);
		return () => document.removeEventListener("keydown", onKeyPress);
	}, [moveElement, rotateElement, setCollisionMode]);
	return null;
};

export default KeyboardManager;
